<template>
  <div class="ielts-training">
    <h1>雅思托福考试培训</h1>
    <div class="service-category">留学服务</div>

    <section class="training-section">
      <div class="intro">
        <p>
          标准化考试成绩是学生大学录取时非常重要的一项内容，它展示了学生的语言交流能力，对于进入大学后快速适应留学环境也有很大的促进作用。很多大学的优势专业往往对语言的要求非常严格，如果发挥好好的语言成绩很容易就被录取。
        </p>
        <p>
          标准化语言考试需要进行系统的学习和训练，这就要求学生要掌握适合自己的快速教学方法，通过有针对性的教学方案来帮助学生掌握一定的学习方式方法，循序渐进、稳步提高，在有限的时间内达到理想的目标，在提高应试成绩的同时提高实际应用语言的能力。
        </p>
      </div>

      <div class="exam-types">
        <h2>考试类型</h2>
        
        <div class="exam-card">
          <h3>雅思考试 (IELTS)</h3>
          <div class="exam-content">
            <h4>考试内容：</h4>
            <ul>
              <li>听力 (Listening)</li>
              <li>阅读 (Reading)</li>
              <li>写作 (Writing)</li>
              <li>口语 (Speaking)</li>
            </ul>
          </div>
        </div>

        <div class="exam-card">
          <h3>托福考试 (TOEFL)</h3>
          <div class="exam-content">
            <h4>考试内容：</h4>
            <ul>
              <li>听力理解</li>
              <li>阅读理解</li>
              <li>写作表达</li>
              <li>口语表达</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="training-services">
        <h2>培训服务</h2>
        <ul>
          <li>
            <h3>个性化教学</h3>
            <p>根据学生的实际水平和目标分数制定个性化的学习计划</p>
          </li>
          <li>
            <h3>专业师资</h3>
            <p>经验丰富的外教和中教团队，确保教学质量</p>
          </li>
          <li>
            <h3>模拟训练</h3>
            <p>定期进行模拟考试，熟悉考试流程和题型</p>
          </li>
          <li>
            <h3>技巧指导</h3>
            <p>传授考试技巧和解题方法，提高应试能力</p>
          </li>
          <li>
            <h3>学习资料</h3>
            <p>提供丰富的学习资料和练习题库</p>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'IELTSTrainingView'
}
</script>

<style scoped lang="less">
.ielts-training {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .service-category {
    color: #666;
    font-size: 18px;
    margin-bottom: 30px;
  }

  .training-section {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    .intro {
      margin-bottom: 40px;

      p {
        margin-bottom: 20px;
        line-height: 1.8;
        color: #444;
      }
    }

    .exam-types {
      margin-bottom: 40px;

      h2 {
        font-size: 24px;
        color: #333;
        margin-bottom: 20px;
      }

      .exam-card {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 20px;

        h3 {
          color: #333;
          margin-bottom: 15px;
          font-size: 20px;
        }

        .exam-content {
          h4 {
            color: #555;
            margin-bottom: 10px;
          }

          ul {
            list-style: none;
            padding: 0;

            li {
              padding: 8px 0;
              color: #666;
              position: relative;
              padding-left: 20px;

              &:before {
                content: '•';
                position: absolute;
                left: 0;
                color: #409EFF;
              }
            }
          }
        }
      }
    }

    .training-services {
      h2 {
        font-size: 24px;
        color: #333;
        margin-bottom: 20px;
      }

      ul {
        list-style: none;
        padding: 0;

        li {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 20px;
          margin-bottom: 15px;
          transition: all 0.3s ease;

          &:hover {
            transform: translateX(10px);
            background: #e9ecef;
          }

          h3 {
            color: #333;
            margin-bottom: 10px;
            font-size: 18px;
          }

          p {
            color: #666;
            margin: 0;
            line-height: 1.6;
          }
        }
      }
    }
  }
}
</style>